import { Box } from '@mui/material';
import React from 'react';

const Unauthorized: React.FC = () => {
    return (
        <Box> Unauthorized </Box>
    )
}

export default Unauthorized;